module.exports = __webpack_public_path__ + "img/Group 1234.326923ba.svg";